import { useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import UserDetailsContext from '../../../contexts/UserDetailsContext/UserDetailsContext';

import { updateRequest } from '../../../stores/AssignDeviceStore';

import UserDetailsInfoRows from './components/UserDetailsInfoRows';
import UserDetailsTabs from './components/UserDetailsTabs';
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
import AddDeviceDrawer from './components/AddDeviceDrawer/AddDeviceDrawer';
import AssignDeviceDrawer from './components/AssignDeviceDrawer/AssignDeviceDrawer';
import AssignSimDrawer from './components/AssignSimDrawer/AssignSimDrawer';
import useUserDetailsTabs from './components/useUserDetailsTabs';
import useUserDetails from './useUserDetails';

function UserDetails() {
  const { id } = useParams();
  const { pathname } = useLocation();
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [showAddDevice, setShowAddDevice] = useState(false);
  const [showAssignDevice, setShowAssignDevice] = useState(false);
  const [showAssignSim, setShowAssignSim] = useState(false);
  const { user, updateUserDetails, isLoading, deleteUserHandler } = useUserDetails(id);
  const {
    devices,
    sims,
    isLoading: tabsLoading,
    resendNotification,
    isPerformingAction,
    getDeviceByDeviceId,
    updateSimDetails,
    deleteDeviceHandler,
    cancelScheduledOperation,
    onActionSuccess,
  } = useUserDetailsTabs();

  /**
   * Init assign device
   */
  const assignDevice = () => {
    dispatch(updateRequest({ userId: user?.id }));
    setShowAssignDevice(true);
  };

  /**
   * Init add device
   */
  const addDevice = () => {
    setShowAddDevice(true);
  };

  /**
   * Init assign sim
   */
  const assignSim = () => {
    setShowAssignSim(true);
  };

  return (
    <UserDetailsContext.Provider value={user}>
      <Breadcrumbs
        activeLinks={[
          ...(pathname.startsWith('/dashboard/devicesReport')
            ? [
                { label: t('navbar.dashboard'), url: '/dashboard' },
                { label: t('pages.devicesReport.title'), url: '/dashboard/devicesReport' },
              ]
            : [{ label: t('navbar.esimManager'), url: '/esimManager' }]),
        ]}
        disabledLinks={[user ? `${user?.firstName} ${user?.lastName}` : '']}
      />

      <UserDetailsInfoRows
        isLoading={isLoading}
        updateUserDetails={updateUserDetails}
        deleteUser={deleteUserHandler}
        assignDevice={assignDevice}
        addDevice={addDevice}
        assignSim={devices.length ? assignSim : undefined}
      />
      <UserDetailsTabs
        devices={devices}
        sims={sims}
        isLoading={tabsLoading}
        resendNotification={resendNotification}
        isPerformingAction={isPerformingAction}
        getDeviceByDeviceId={getDeviceByDeviceId}
        updateSimDetails={updateSimDetails}
        deleteDeviceHandler={deleteDeviceHandler}
        cancelScheduledOperation={cancelScheduledOperation}
        onActionSuccess={onActionSuccess}
        assignDevice={assignDevice}
        addDevice={addDevice}
        assignSim={assignSim}
      />
      {showAddDevice ? (
        <AddDeviceDrawer
          onClose={() => {
            setShowAddDevice(false);
          }}
          open={showAddDevice}
          onAddDeviceSuccess={onActionSuccess}
        />
      ) : null}
      {showAssignDevice ? (
        <AssignDeviceDrawer
          onClose={() => {
            setShowAssignDevice(false);
          }}
          open={showAssignDevice}
          onAssignSuccess={onActionSuccess}
        />
      ) : null}
      {showAssignSim ? (
        <AssignSimDrawer
          onClose={() => {
            setShowAssignSim(false);
          }}
          open={showAssignSim}
          onAssignSimSuccess={onActionSuccess}
        />
      ) : null}
    </UserDetailsContext.Provider>
  );
}
export default UserDetails;
